// services/wordpress.js

const WORDPRESS_API_URL = 'https://www.cms.org/wp-json';

export const loginWordpress = async (username, password) => {
  const res = await fetch(`${WORDPRESS_API_URL}/custom/v1/login`, {
    method: 'POST',
    headers: {  
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      username,
      password,
    }),
  });

  if (!res.ok) {
    throw new Error('Login failed');
  }

  const data = await res.json();
  return data;
};
